<div fxLayout="row" fxLayoutAlign="center center" class="mt-2">
    <div fxFlex="100" fxFlex.gt-sm="1 1 400px" fxFlex.sm="1 1 400px" class="mat-elevation-z6">

        <div fxLayout="row" fxLayoutAlign="space-between center" class="p-3">
            <div class="p-2" fxFlex style="font-size: 1.2em; font-weight: bold;">{{ schedulerName }}</div>
            <button mat-stroked-button (click)="back()">
                <mat-icon matSuffix class="mat-icon-rtl-mirror">navigate_before</mat-icon>
                {{ 'FUTURE-VISITS.BACK' | translate}}
            </button>
        </div>

        <div fxLayout="row" fxLayoutAlign="center center" class="mt-2">
            <div class="container" fxFlex>
                <div *ngFor="let currentItem of findTimeList">
                    <div fxLayout="column" class="w-100 itemContainer p-3">
                        <div fxLayout="row" fxLayoutAlign="space-between center" class="h-100">

                            <div fxLayout="column" fxFlex='70%'>
                                <div>
                                    <span>{{ currentItem.Date | amDateFormat:'ddd' }}</span>
                                    <span class="m-1">|</span>
                                    <span>{{ currentItem.Date | amDateFormat:'L' }}</span>
                                    <span class="m-1">|</span>
                                    <span>{{ currentItem.StartTime }}</span>
                                </div>
                                <div><b>{{ currentItem.CityName}}, </b>{{ currentItem.Address }}</div>
                            </div>

                            <div fxFlex fxLayoutAlign='end' class="p-1">
                                <div fxLayout="column">
                                    <button mat-raised-button (click)="onSelect(currentItem)" color="accent">
                                        {{ 'FIND-TIME.ADD-APPOINTMENT' | translate }}
                                    </button>
                                    <span *ngIf="currentItem.OverlapEventsCount>0" class="color1">{{ 'COMMON.OVERLAP-COUNT-MSG' | translate: { 'count': currentItem.OverlapEventsCount} }}</span>
                                </div>
                                
                                
                            </div>
                        </div>
                    </div>
                </div>

                 <div class="accent" fxLayoutAlign="center" *ngIf="showNoItemsFoundMessage">
                    <b>{{ 'FIND-TIME.NO-AVAILABLE-TIME-FOUND' | translate }}</b>
                </div> 

            </div>
        </div>
    </div>
</div>